<template>
  <div>
    <Header Act="7"></Header>
    <div class="all-works">
      <div class="page-header">
        <div class="back-btn" @click="goBack">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
        <h2>{{ pageTitle }}</h2>
      </div>

      <div class="works-grid">
        <div
          v-for="item in worksList"
          :key="item.id"
          class="works-item"
          :data-type="worksType"
          :data-item-id="item.id"
          @click="handleItemClick(item)"
        >
          <div class="works-player-wrap">
            <div class="works-container">
              <!-- 文章类型 -->
              <template v-if="worksType === '1'">
                <!-- <img 
                  src="../../assets/applyRey/word.png" 
                  :alt="item.worksName" 
                  class="works-cover"
                  @load="handleImageLoad(item.id)"
                  @error="handleImageError(item.id)"
                  :style="{ display: loadingImages[item.id] ? 'none' : 'block' }"
                > -->
                <img
                  :src="
                    item.picFile ||
                    'https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/workPicFile_1753257623410_pdf.png'
                  "
                  :alt="item.worksName"
                  class="works-cover"
                  @load="handleImageLoad(item.id)"
                  @error="handleImageError(item.id)"
                  :style="{
                    display: loadingImages[item.id] ? 'none' : 'block',
                  }"
                />
                <div v-if="loadingImages[item.id]" class="loading-overlay">
                  <i class="el-icon-loading"></i>
                </div>
              </template>

              <!-- 图片类型 -->
              <template v-else-if="worksType === '2'">
                <img
                  :src="
                    item.picFile ||
                    'https://via.placeholder.com/400x300?text=暂无图片'
                  "
                  :alt="item.worksName"
                  class="works-cover"
                  @load="handleImageLoad(item.id)"
                  @error="handleImageError(item.id)"
                  :style="{
                    display: loadingImages[item.id] ? 'none' : 'block',
                  }"
                />
                <div v-if="loadingImages[item.id]" class="loading-overlay">
                  <i class="el-icon-loading"></i>
                </div>
              </template>

              <!-- 视频类型 -->
              <div v-else class="video-container">
                <img
                  v-if="item.picFile"
                  :src="item.picFile"
                  :alt="item.worksName"
                  class="works-cover"
                  @load="handleImageLoad(item.id)"
                  @error="handleImageError(item.id)"
                  :style="{
                    display: loadingImages[item.id] ? 'none' : 'block',
                  }"
                />
                <el-image
                  v-else
                  :alt="item.worksName"
                  class="works-cover"
                  fit="cover"
                >
                  <div slot="placeholder" class="loading-overlay">
                    <i class="el-icon-loading"></i>
                  </div>
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <div
                  v-if="loadingImages[item.id] || loadingThumbnails[item.id]"
                  class="loading-overlay"
                >
                  <i class="el-icon-loading"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="works-title">{{ item.worksName }}</div>
        </div>
      </div>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          :total="total"
          layout="total, prev, pager, next"
        >
        </el-pagination>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../header/head.vue";
import Footer from "../header/footer.vue";
import axios from "axios";

export default {
  name: "AllWorks",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      worksType: "",
      worksList: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      loadingThumbnails: {},
      loadingImages: {},
      thumbnailCache: new Map(),
      typeNames: {
        1: "培训文件",
        2: "培训图画",
        3: "培训视频",
        4: "培训讲座",
      },
      // defaultPoster: require('../../assets/applyRey/default-poster.png'),
      observerMap: new Map(),
      activeVideoElements: new Set(), // 存储活动的视频元素
      isComponentActive: true, // 标记组件是否处于活动状态
      thumbnailPromises: [], // 存储所有缩略图生成的Promise
      // 固定内容数据
      fixedContent: {
        1: [
          // 科普文章
          {
            id: "fixed_article_1",
            worksName:
              "【执行手册】健康中国行动-百姓健康卫士公益科普“百姓巡常行”作品征集活动",
            worksType: "1",
            workFile:
              "https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/【执行手册】健康中国行动-百姓健康卫士公益科普“百姓巡常行”作品征集活动.pdf",
            projectCase: "执行手册",
            userName: "征集平台",
            userUnit: "无",
            des: "固定置顶文章",
            thumbnailUrl:
              "https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/workPicFile_1753257623410_pdf.png",
          },
          {
            id: "fixed_article_2",
            worksName: "学术初审及创作者劳务签署平台操作流程",
            worksType: "1",
            workFile:
              "https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/学术初审及创作者劳务签署平台操作流程.pdf",
            projectCase: "执行手册",
            userName: "征集平台",
            userUnit: "无",
            des: "固定置顶文章",
            thumbnailUrl:
              "https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/workPicFile_1753257623410_pdf.png",
          },
          {
            id: "fixed_article_3",
            worksName: "专家复审执行手册",
            worksType: "1",
            workFile:
              "https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/专家复审执行手册.pdf",
            projectCase: "执行手册",
            userName: "征集平台",
            userUnit: "无",
            des: "固定置顶文章",
            thumbnailUrl:
              "https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/workPicFile_1753257623410_pdf.png",
          },
          {
            id: "fixed_article_4",
            worksName: "科普文章样稿",
            worksType: "1",
            workFile:
              "https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/uploads/1/1758006115183_bm30py.docx",
            projectCase: "科普文章",
            userName: "征集平台",
            userUnit: "无",
            des: "固定置顶文章",
            thumbnailUrl:
              "https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/workPicFile_1753257623410_pdf.png",
          },
        ],
        3: [
          // 科普短视频
          {
            id: "fixed_video_1",
            worksName: "内容规范123321",
            worksType: "3",
            workVedioFile:
              "https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/11233_内容规范.mp4",
            projectCase: "科普短视频",
            userName: "征集平台",
            userUnit: "无",
            des: "固定置顶短视频",
            thumbnailUrl:
              "https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/拍摄.jpg",
          },
          {
            id: "fixed_video_2",
            worksName: "拍摄规范",
            worksType: "3",
            workVedioFile:
              "https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/11232_拍摄规范.mp4",
            projectCase: "科普短视频",
            userName: "征集平台",
            userUnit: "无",
            des: "固定置顶短视频",
            thumbnailUrl:
              "https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/拍摄.jpg",
          },
          {
            id: "fixed_video_3",
            worksName: "科普讲座样片",
            worksType: "3",
            workVedioFile:
              "https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/3a443537fbce89445b860d7c9b335037.mp4",
            projectCase: "科普讲座",
            userName: "征集平台",
            userUnit: "无",
            des: "固定置顶讲座",
            thumbnailUrl:
              "https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/13908_thumbnail_20250714105941A911.jpg",
          },
          {
            id: "fixed_video_4",
            worksName: "科普短视频样片1",
            worksType: "3",
            workVedioFile:
              "https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/科普短视频样片1.mp4",
            projectCase: "科普短视频",
            userName: "征集平台",
            userUnit: "无",
            des: "固定置顶短视频",
            thumbnailUrl:
              "https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/workPicFile_1758075801788_thumbnail_20250917094051A003.jpg",
          },
          {
            id: "fixed_video_5",
            worksName: "科普短视频样片2",
            worksType: "3",
            workVedioFile:
              "https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/科普视频样片2.mp4",
            projectCase: "科普短视频",
            userName: "征集平台",
            userUnit: "无",
            des: "固定置顶短视频",
            thumbnailUrl:
              "https://bxxcx-bahimorgcn.oss-cn-beijing.aliyuncs.com/vedio/workPicFile_1758075801788_thumbnail_20250917094051A003.jpg",
          },
        ],
      },
    };
  },
  computed: {
    pageTitle() {
      return this.typeNames[this.worksType] || "全部作品";
    },
  },
  created() {
    this.worksType = this.$route.query.worksType;
    this.fetchData();
  },
  methods: {
    // 加载固定数据，不调用接口
    loadFixedData() {
      const fixedItems = this.fixedContent[this.worksType] || [];
      this.worksList = fixedItems;
      this.total = fixedItems.length;

      // 重置所有加载状态
      this.worksList.forEach((item) => {
        this.$set(this.loadingImages, item.id, false);
      });

      // 如果是视频类型，处理缩略图
      if (this.worksType === "3" || this.worksType === "4") {
        this.processVideoThumbnails(this.worksList);
      }
    },

    async fetchData() {
      try {
        // 调用培训数据接口，支持分页
        const response = await this.$get(
          `/system/peixun/list?type=${this.worksType}&pageNum=${this.currentPage}&pageSize=${this.pageSize}`,
        );

        if (response.data.code === 200) {
          this.worksList = response.data.rows || [];
          this.total = response.data.total || 0;

          // 重置所有加载状态
          this.worksList.forEach((item) => {
            this.$set(this.loadingImages, item.id, false);
          });

          // 如果是视频类型，处理缩略图
          if (this.worksType === "3" || this.worksType === "4") {
            this.processVideoThumbnails(this.worksList);
          }
        } else {
          console.error("获取数据失败:", response.data.msg);
          this.$message.error(response.data.msg || "获取数据失败");
        }
      } catch (error) {
        console.error("获取数据失败:", error);
        this.$message.error("获取数据失败，请稍后重试");
      }
    },

    async processVideoThumbnails(items) {
      // 创建 IntersectionObserver
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const itemId = entry.target.dataset.itemId;
              const item = this.worksList.find((i) => i.id === itemId);
              if (item) {
                this.loadThumbnail(item);
                observer.unobserve(entry.target);
              }
            }
          });
        },
        {
          rootMargin: "50px 0px", // 提前50px开始加载
          threshold: 0.1,
        },
      );

      // 存储observer以便后续清理
      this.observerMap.set("thumbnail", observer);

      items.forEach((item) => {
        if (item.vedioFile) {
          // 设置初始加载状态
          this.$set(this.loadingImages, item.id, true);

          // 获取容器元素并添加观察
          this.$nextTick(() => {
            const container = document.querySelector(
              `[data-item-id="${item.id}"]`,
            );
            if (container) {
              observer.observe(container);
            }
          });
        }
      });
    },

    async loadThumbnail(item) {
      const videoUrl = item.vedioFile;
      if (!videoUrl) return;

      try {
        // 检查缓存
        if (this.thumbnailCache.has(videoUrl)) {
          const cachedThumbnail = this.thumbnailCache.get(videoUrl);
          this.updateThumbnail(item.id, cachedThumbnail);
          return;
        }

        const thumbnail = await this.getVideoThumbnail(videoUrl);
        if (thumbnail) {
          // 存入缓存
          this.thumbnailCache.set(videoUrl, thumbnail);
          this.updateThumbnail(item.id, thumbnail);
        }
      } catch (error) {
        console.error("处理视频缩略图失败:", error);
      } finally {
        this.$set(this.loadingImages, item.id, false);
      }
    },

    updateThumbnail(itemId, thumbnailUrl) {
      const index = this.worksList.findIndex((item) => item.id === itemId);
      if (index !== -1) {
        this.$set(this.worksList[index], "picFile", thumbnailUrl);
      }
    },

    // 清理所有视频相关资源
    cleanupVideoResources() {
      this.isComponentActive = false;
      this.thumbnailPromises = [];

      // 清理所有活动的视频元素
      this.activeVideoElements.forEach((video) => {
        try {
          // 停止所有媒体加载
          video.pause();
          video.removeAttribute("src");
          video.load();
          // 移除所有事件监听器
          video.onloadeddata = null;
          video.onseeked = null;
          video.onerror = null;
          // 清空视频源
          video.src = "";
          // 移除视频元素
          video.remove();
        } catch (error) {
          console.error("清理视频元素失败:", error);
        }
      });
      this.activeVideoElements.clear();

      // 重置加载状态
      Object.keys(this.loadingThumbnails).forEach((key) => {
        this.$set(this.loadingThumbnails, key, false);
      });

      // 清理所有视频引用
      if (this.$refs.videoRefs) {
        this.$refs.videoRefs.forEach((video) => {
          if (video) {
            try {
              video.pause();
              video.removeAttribute("src");
              video.load();
              video.onloadeddata = null;
              video.onseeked = null;
              video.onerror = null;
              video.src = "";
            } catch (error) {
              console.error("清理视频引用失败:", error);
            }
          }
        });
      }

      // 清空视频数据
      this.videos = [];
    },

    // 修改生成视频缩略图的方法
    async getVideoThumbnail(videoUrl) {
      if (!videoUrl || !this.isComponentActive) return null;

      try {
        return new Promise((resolve, reject) => {
          const video = document.createElement("video");
          this.activeVideoElements.add(video);

          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");

          video.crossOrigin = "anonymous";
          let retryCount = 0;
          const maxRetries = 10;

          const cleanupVideo = () => {
            try {
              video.pause();
              video.removeAttribute("src");
              video.load();
              video.onloadeddata = null;
              video.onseeked = null;
              video.onerror = null;
              video.src = "";
              video.remove();
            } catch (error) {
              console.error("清理视频元素失败:", error);
            }
            this.activeVideoElements.delete(video);
          };

          const tryCapture = () => {
            if (!this.isComponentActive) {
              cleanupVideo();
              resolve(null);
              return;
            }

            try {
              if (video.readyState >= 3) {
                // ... existing video capture code ...
                cleanupVideo();
                resolve(thumbnailUrl);
              } else if (retryCount < maxRetries) {
                retryCount++;
                setTimeout(tryCapture, 1000);
              } else {
                video.load();
                retryCount = 0;
                setTimeout(tryCapture, 2000);
              }
            } catch (error) {
              if (!this.isComponentActive) {
                cleanupVideo();
                resolve(null);
                return;
              }
              if (retryCount < maxRetries) {
                retryCount++;
                setTimeout(tryCapture, 1000);
              } else {
                video.load();
                retryCount = 0;
                setTimeout(tryCapture, 2000);
              }
            }
          };

          // 设置超时清理
          const timeoutId = setTimeout(() => {
            if (this.activeVideoElements.has(video)) {
              cleanupVideo();
              resolve(null);
            }
          }, 30000); // 30秒超时

          video.onloadeddata = () => {
            if (this.isComponentActive) {
              video.currentTime = 0;
            } else {
              cleanupVideo();
              resolve(null);
            }
          };

          video.onseeked = tryCapture;
          video.onerror = () => {
            if (!this.isComponentActive) {
              cleanupVideo();
              resolve(null);
              return;
            }
            if (retryCount < maxRetries) {
              retryCount++;
              setTimeout(() => {
                video.load();
                tryCapture();
              }, 2000);
            } else {
              video.load();
              retryCount = 0;
              setTimeout(tryCapture, 2000);
            }
          };

          // 在Promise resolve时清理超时计时器
          const originalResolve = resolve;
          resolve = (value) => {
            clearTimeout(timeoutId);
            originalResolve(value);
          };

          video.src = videoUrl;
          video.preload = "auto";
        });
      } catch (error) {
        console.error("获取视频缩略图失败:", error);
        if (this.isComponentActive) {
          return this.getVideoThumbnail(videoUrl);
        }
        return null;
      }
    },

    handleItemClick(item) {
      // 统一跳转到 SampleVideo.vue，使用peixunvideoId参数
      this.$router.push({
        path: "/sample-video",
        query: {
          peixunvideoId: item.id,
        },
      });
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchData();
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },

    goBack() {
      this.$router.go(-1);
    },

    handleImageLoad(itemId) {
      this.$set(this.loadingImages, itemId, false);
    },

    handleImageError(itemId) {
      this.$set(this.loadingImages, itemId, false);
    },

    beforeDestroy() {
      // 清理 IntersectionObserver
      this.observerMap.forEach((observer) => {
        observer.disconnect();
      });
      this.observerMap.clear();

      // 清理缓存
      this.thumbnailCache.clear();

      // 清理所有视频相关资源
      this.cleanupVideoResources();
    },
    deactivated() {
      // 组件被停用时清理视频状态
      this.cleanupVideoResources();
    },
    activated() {
      // 组件被激活时重置状态
      this.isComponentActive = true;
    },
  },
};
</script>

<style scoped>
.all-works {
  padding: 20px;
  min-height: calc(100vh - 200px);
  background: #f5f5f5;
}

.page-header {
  position: relative;
  margin-bottom: 30px;
  padding: 0 20px;
}

.back-btn {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  color: #666;
  font-size: 14px;
  padding: 8px 12px;
  border-radius: 4px;
  transition: all 0.3s;
}

.back-btn:hover {
  color: #409eff;
  background: #ecf5ff;
}

.back-btn i {
  margin-right: 4px;
}

h2 {
  text-align: center;
  margin: 20px 0;
  font-size: 24px;
  color: #333;
}

.works-grid {
  display: grid;
  grid-template-columns: repeat(5, 248px);
  gap: 20px;
  margin: 20px auto;
  max-width: 1340px;
  padding: 0 30px;
  justify-content: center;
}

.works-item {
  display: flex;
  flex-direction: column;
  cursor: pointer;
  transition: all 0.3s;
  width: 248px;
}

.works-item:hover {
  transform: translateY(-5px);
}

.works-player-wrap {
  width: 248px;
  height: 440px;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.works-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
}

.works-cover {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.works-item[data-type="1"] .works-cover {
  padding: 0;
  width: 100% !important;
  height: auto !important;
  object-fit: contain !important;
  margin: 0 !important;
}

.works-item[data-type="2"] .works-cover {
  object-fit: cover;
}

.works-item[data-type="3"] .works-cover,
.works-item[data-type="4"] .works-cover {
  object-fit: contain;
  padding: 0;
}

.video-container {
  width: 100%;
  height: 100%;
  position: relative;
  background: #000;
}

.video-container .works-cover {
  object-fit: cover;
}

.works-item[data-type="4"] .video-container .works-cover {
  object-fit: contain;
}

.works-title {
  margin-top: 10px;
  font-size: 14px;
  color: #333;
  text-align: center;
  padding: 0 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 248px;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
}

.image-slot i {
  font-size: 30px;
}

.pagination-container {
  text-align: center;
  margin: 30px 0;
}

@media screen and (max-width: 1400px) {
  .works-grid {
    grid-template-columns: repeat(4, 248px);
    max-width: 1092px;
  }
}

@media screen and (max-width: 1200px) {
  .works-grid {
    grid-template-columns: repeat(3, 248px);
    max-width: 804px;
  }
}

@media screen and (max-width: 768px) {
  .works-grid {
    display: flex;
    gap: 10px;
    padding-bottom: 20px;
    flex-wrap: wrap;
    justify-content: center;
  }

  .works-item {
    width: calc(50% - 5px);
    max-width: 240px;
    margin-bottom: 10px;
  }

  .works-player-wrap {
    width: 100%;
    height: 200px;
  }

  .works-title {
    font-size: 12px;
    margin-top: 5px;
    width: 100%;
    max-width: 100%;
  }
}

@media screen and (max-width: 480px) {
  .works-grid {
    gap: 8px;
    padding: 0 8px;
  }

  .works-item {
    width: calc(50% - 4px);
  }

  .works-player-wrap {
    height: 180px;
  }

  .pagination-container :deep(.el-pagination) {
    padding: 0 5px;
    font-size: 12px;
  }

  .pagination-container :deep(.el-pagination button) {
    min-width: 24px;
  }

  .pagination-container :deep(.el-pagination .el-pager li) {
    min-width: 24px;
    margin: 0 1px;
    font-size: 12px;
  }
}
</style>
